import Color from "color"

import { PRIMARY_PURPLE } from "@podcastsoundboard/ps-lib/colors"
import { Box, Tooltip } from "@podcastsoundboard/ps-lib/ui"

const DEFAULT_COLOR = PRIMARY_PURPLE
const HEIGHT = "0.25rem"

export default function VolumeBar({
  color,
  currentVolume,
}: {
  color: string
  currentVolume: number
}) {
  return (
    <Tooltip title="Current volume" className="text-white shrink-0">
      <Box
        style={{
          height: HEIGHT,
          position: "relative",
        }}
      >
        <div
          style={{
            backgroundColor: Color(color || DEFAULT_COLOR)
              .darken(0.2)
              .hex(),
            height: HEIGHT,
            position: "absolute",
            top: 0,
            left: 0,
            width: `${(currentVolume || 0) * 100}%`,
          }}
        />
      </Box>
    </Tooltip>
  )
}
